<template>
  <div class="container_self">
    <el-row class="eventList" v-loading="loading">
      <el-row style="height: 40px; line-height: 40px;display:flex;justify-content: space-between;">
        <h3 style="width:100%">H5 事件触发统计</h3>
        <!-- <el-button-group style="float: right; display: inline-block" class="btn-group">
          <el-button :type="type1" @click="dateChange(1)">本日</el-button>
          <el-button :type="type2" @click="dateChange(2)">本周</el-button>
          <el-button :type="type3" @click="dateChange(3)">本月</el-button>
          <el-button :type="type4" @click="dateChange(4)">本季度</el-button>
        </el-button-group> -->

        <el-date-picker
          v-model="dateZoom"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :value-format="'yyyy-MM-ddTHH:mm:ss.000Z'"
          :default-timezone="0"
          :picker-options="pickerOptions">
        </el-date-picker>

        <el-button type="warning" style="margin-left:15px" @click="checkEvents">查询</el-button>
      </el-row>
      <el-row class="event_parent">
        <el-col
          :span="4"
          v-for="(item, index) in eventList"
          :key="index"
          class="sm-card-parent"
        >
          <el-card
            class="box-card small-card"
            @click.native="getEventDetail(item.name)"
            :class="currentItem == item.name ? 'activeItem' : ''"
          >
            <h4>{{ item.nameText }}</h4>
            <span>{{ item.count }} {{ item.unit }}</span>
          </el-card>
        </el-col>
      </el-row>

      <el-row class="event_chart_parent">
        <h3>H5 事件趋势图</h3>

        <el-row id="event_chart_h5" style="width: 100%; height: 440px"></el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
import * as echarts from "echarts";
import {
  formateDateLong,
  formateDate,
  getTimeInterVal,
} from "@/assets/dateUtils.js";
export default {
  data() {
    return {
      eventList: [
        { name: "pageEnterEvent", count: 0, nameText: "进入页面", unit: "次" },
        // { name: "pageReadyEvent", count: 0, nameText: "页面资源加载完成", unit: "次" },
        // { name: "pageExitEvent", count: 0, nameText: "页面退出", unit: "次" },
        // { name: "adDivP1VisibleEvent", count: 0, nameText: "P1可见", unit: "次" },
        // { name: "adDivP2VisibleEvent", count: 0, nameText: "P2可见", unit: "次" },
        // { name: "adDivP1DisVisibleEvent", count: 0, nameText: "P1不可见", unit: "次" },
        // { name: "adDivP2DisVisibleEvent", count: 0, nameText: "P2不可见", unit: "次" },
        // { name: "adDivPMDisVisibleEvent",count: 0,nameText: "可见区域小于百分之50",unit: "次"},
        // { name: "scrollEvent",count: 0,nameText: "页面滚动事件",unit: "次"},
        // { name: "clickEvent",count: 0,nameText: "页面点击事件",unit: "次"},
        { name: "adInitEvent", count: 0, nameText: "ad初始化", unit: "次" },
        { name: "adFilledEvent", count: 0, nameText: "广告填充", unit: "次" },
        { name: "adFilledSuccess", count: 0, nameText: "广告填充成功", unit: "次" }
      ],
      currentItem: "pageEnterEvent",
      chartsElement: null,
      xData: [],
      yData: [],
      title: "",
      start: formateDate(formateDateLong(new Date())),
      end:formateDate(formateDateLong(new Date())),
      // type1: "primary",
      // type2: "default",
      // type3: "default",
      // type4: "default",
      loading:false,
      string:"pageEnterEvent",//,pageReadyEvent,pageExitEvent,adDivP1VisibleEvent,adDivP2VisibleEvent,adDivP1DisVisibleEvent,adDivP2DisVisibleEvent,adDivPMDisVisibleEvent,adInitEvent,adFilledEvent,scrollEvent,clickEvent
      dateZoom:[formateDate(formateDateLong(new Date().getTime())),formateDate(formateDateLong(new Date()))],
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = formateDateLong(new Date().getTime());
              const start = formateDateLong(new Date().getTime());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = formateDateLong(new Date().getTime());
              const start = formateDateLong(new Date().getTime());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = formateDateLong(new Date().getTime());
              const start = formateDateLong(new Date().getTime());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  mounted() {
    this.geteventList(this.string,"");
  },
  methods: {
    checkEvents(){
      this.start=formateDate(this.dateZoom[0]);
      this.end=formateDate(this.dateZoom[1]);
      this.geteventList(this.string,"");
    },
   async geteventList(eventsString,status) {
    this.loading=true;
    await  axiosGet(
        "/api/statistics/web/event?start=" +
          this.start +
          " 00:00:00" +
          "&end=" +
          this.end +
          " 23:59:59"+
          '&names='+eventsString+
          '&status='+status
      ).then((res) => {
        if (res.code === 0) {
          this.loading = false;
            if (res.data.length) {
              for (const event of this.eventList) {
                const { name } = event;
                const { count = 0 } = res.data.find((item) => item.name === name) || {};
                event.count = count;
              }
              this.getEventDetail(this.eventList[0].name);
            } else {
              this.eventList = [
                { name: "pageEnterEvent", count: 0, nameText: "进入页面", unit: "次" },
                // { name: "pageReadyEvent", count: 0, nameText: "页面资源加载完成", unit: "次" },
                // { name: "pageExitEvent", count: 0, nameText: "页面退出", unit: "次" },
                // { name: "adDivP1VisibleEvent", count: 0, nameText: "P1可见", unit: "次" },
                // { name: "adDivP2VisibleEvent", count: 0, nameText: "P2可见", unit: "次" },
                // { name: "adDivP1DisVisibleEvent", count: 0, nameText: "P1不可见", unit: "次" },
                // { name: "adDivP2DisVisibleEvent", count: 0, nameText: "P2不可见", unit: "次" },
                // { name: "adDivPMDisVisibleEvent",count: 0,nameText: "可见区域小于百分之50",unit: "次"},
                // { name: "scrollEvent",count: 0,nameText: "页面滚动事件",unit: "次"},
                // { name: "clickEvent",count: 0,nameText: "页面点击事件",unit: "次"},
                { name: "adInitEvent", count: 0, nameText: "ad初始化", unit: "次" },
                { name: "adFilledEvent", count: 0, nameText: "广告填充", unit: "次" },
                { name: "adFilledSuccess", count: 0, nameText: "广告填充成功", unit: "次" }
              ];
            }
          }
      });
      await  axiosGet(
        "/api/statistics/web/event?start=" +
          this.start +
          " 00:00:00" +
          "&end=" +
          this.end +
          " 23:59:59"+
          '&names=adFilledEvent'+
          '&status=success'
      ).then(res=>{
        if(res.code==0){
          if(res.data.length){
            this.eventList[3].count=res.data[0].count;
          }

        }
      })
    },
    drawChart(x, y, title) {
      this.chartsElement = echarts.init(document.getElementById("event_chart_h5"));
      let option = {
        title: {
          text: title,
          x: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: x,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: y,
            type: "line",
            smooth: true,
            symbol: "none", //取消折点圆圈
          },
        ],
      };
      this.chartsElement.setOption(option);
    },
    getEventDetail(name) {
      this.loading=true;
      if(name=='adFilledSuccess'){
        this.$message({message:'事件不可查询',type:'error'});
        this.loading=false;
        return false;
      }
      this.xData = [];
      this.yData = [];
      axiosGet(
        "/api/statistics/web/event_trend?end=" +
          this.end +
          " 23:59:59" +
          "&start=" +
          this.start +
          " 00:00:00" +
          "&name=" +
          name
      ).then((res) => {
        if (res.code == 0) {
          this.currentItem = name;
          this.loading=false;
          if (res.data.length) {
            for (var i = 0; i < res.data.length; i++) {
              if (getTimeInterVal(this.start, this.end) == "oneDay") {
                this.xData.push(res.data[i].time.split(" ")[1]);
              } else {
                this.xData.push(res.data[i].time);
              }
              this.yData.push(res.data[i].count);
            }
            this.drawChart(this.xData, this.yData, name);
          }else{
            this.$message({message:'事件数据为空',type:'error'})
          }
        }
      });
    },
    // dateChange(val) {
    //   if (val == 1) {
    //     this.start = formateDate(new Date());
    //     this.end = formateDate(new Date());
    //     this.type1 = "primary";
    //     this.type2 = "default";
    //     this.type3 = "default";
    //     this.type4 = "default";
    //   } else if (val == 2) {
    //     this.interval = 1;
    //     this.start = formateDate(getWeekDates().start);
    //     this.end = formateDate(getWeekDates().end);
    //     this.type1 = "default";
    //     this.type2 = "primary";
    //     this.type3 = "default";
    //     this.type4 = "default";
    //   } else if (val == 3) {
    //     this.start = formateDate(getFirstAndLastDayOfMonth().firstDay);
    //     this.end = formateDate(getFirstAndLastDayOfMonth().lastDay);
    //     this.type1 = "default";
    //     this.type2 = "default";
    //     this.type3 = "primary";
    //     this.type4 = "default";
    //   } else {
    //     this.start = formateDate(getFirstDayOfQuarter());
    //     this.end = formateDate(getLastDayOfQuarter());
    //     this.type1 = "default";
    //     this.type2 = "default";
    //     this.type3 = "default";
    //     this.type4 = "primary";
    //   }
    //   let string="pageEnterEvent,pageReadyEvent,pageExitEvent,adDivP1VisibleEvent,adDivP2VisibleEvent,adDivP1DisVisibleEvent,adDivP2DisVisibleEvent,adDivPMDisVisibleEvent,adInitEvent,adFilledEvent";
    //   this.geteventList(string,"");
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/h5Events.vue